import {
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var DispatcherClass;
function Dispatcher() {
  if (DispatcherClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'Dispatcher', VOID, VOID, VOID, [1]);
    DispatcherClass = $;
  }
  return DispatcherClass;
}
var SavePlayerCommandClass;
function SavePlayerCommand() {
  if (SavePlayerCommandClass === VOID) {
    class $ {
      constructor(partyId, player) {
        this.c2l_1 = partyId;
        this.d2l_1 = player;
      }
      toString() {
        return 'SavePlayerCommand(partyId=' + this.c2l_1.toString() + ', player=' + this.d2l_1.toString() + ')';
      }
      hashCode() {
        var result = this.c2l_1.hashCode();
        result = imul(result, 31) + this.d2l_1.hashCode() | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof SavePlayerCommand()))
          return false;
        if (!this.c2l_1.equals(other.c2l_1))
          return false;
        if (!this.d2l_1.equals(other.d2l_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'SavePlayerCommand');
    SavePlayerCommandClass = $;
  }
  return SavePlayerCommandClass;
}
//region block: exports
export {
  Dispatcher as Dispatcher39hthxqv8voqz,
  SavePlayerCommand as SavePlayerCommand2ifdfeyjpvr4j,
};
//endregion

//# sourceMappingURL=SavePlayerCommand.mjs.map
